export const MAX_ZOOM = 20;

export const MIN_ZOOM = 0.01;
